<template>
  <page-layout title="我的BOM" class="p-MyBOM">
    <header class="c-tradingcenter-search-header clearfix">
      <div class="c-tradingcenter-search-header-fl">
        <znl-input
          width="180px"
          :height="30"
          :border="true"
          placeholder="BOM名称"
          class="header-marginleft"
          :clearable="true"
          title-width="60px"
          v-model="BomName"
          @keydown.enter="seachHandler"
        >
        </znl-input>
        <znl-input
          :border="true"
          v-model="dataTime"
          :height="30"
          date-type="daterange"
          form-type="datepicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="true"
          class="header-marginleft"
          @change="dataTimeChange"
          ref="dateinput"
          title-width="60px"
        >
        </znl-input>

        <znl-button
          :width="60"
          :height="30"
          style-type="main"
          class="header-marginleft"
          @click="seachHandler"
        >
          <i class="iconfont icon-sousuo"></i>
          搜索
        </znl-button>

        <znl-button
          :width="60"
          :height="30"
          class="header-marginleft"
          @click="clearParams"
        >
          <i class="iconfont icon-refresh"></i>
          重置
        </znl-button>
      </div>
    </header>

    <div>
      <grid
        v-loading="loading"
        element-loading-text="数据加载中.."
        :columns="columns"
        :datas="datas"
        ref="grid"
        :total-count="totalCount"
        :page-size="pageSize"
        :page-index="pageIndex"
        :on-page-changed="onBindData"
        domLayout="autoHeight"
      ></grid>
    </div>
  </page-layout>
</template>

<script>
import PageLayout from '../PageLayout';
import { httpPost, httpGet } from '../../assets/scripts/http';
import { columns } from './columns';
import { CONFIG as Config } from '../../assets/scripts/config';

export default {
  name: 'PurchaseOrder',
  components: {
    PageLayout
  },
  props: {
    isZnl: Boolean
  },
  data() {
    return {
      dataTime: ['', ''],
      loading: false,
      datas: [],
      columns,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 1,
      BomName: ''
    };
  },
  created() {
    this.onBindData();
  },
  watch: {
    isZnl(v) {
      if (v) {
        this.initColumns();
      }
    }
  },
  methods: {
    initColumns() {
      const vm = this;

      const { isZnl } = vm;

      const Cols = columns.map(col => {
        return {
          field: col.field,
          headerName: col.headerName,
          cellClass: col.cellClass,
          cellRenderer: col.cellRenderer,
          valueFormatter: col.valueFormatter,
          hide: col.hide,
          cellStyle: col.cellStyle,
          width: col.width
        };
      });

      if (isZnl) {
        const FromCompanyNameColumn = Cols.find(item => {
          return item.field === 'FromCompanyName';
        });
        if (FromCompanyNameColumn) {
          FromCompanyNameColumn.hide = false;
        }
        const StatusColumn = Cols.find(item => {
          return item.field === 'Status';
        });
        if (StatusColumn) {
          StatusColumn.hide = false;
        }
      }

      const OperationColumn = Cols.find(item => {
        return item.field === 'Operation';
      });
      if (OperationColumn) {
        OperationColumn.cellRendererFramework = 'GridRenderCellButtons';
        const cellRendererParams = {
          buttons: [
            {
              text: '导出',
              click(params) {
                vm.exportExcel(params.data);
              }
            },
            {
              text: '详情',
              click(params) {
                const Hostname = location.hostname;
                let MyBOMDetailUrl = `https://mm.bom.ai/#/BomMatching?id=${params.data.ID}`;
                if (/^(test)/.test(Hostname)) {
                  MyBOMDetailUrl = `http://test.bom.ai:8080/#/BomMatching?id=${params.data.ID}`;
                }
                if (/^(local)/.test(Hostname)) {
                  MyBOMDetailUrl = `http://localhost:8080/#/BomMatching?id=${params.data.ID}`;
                }
                window.open(MyBOMDetailUrl, 'BOMAI');
              }
            }
            // {
            //   text: '删除',
            //   click(params) {
            //     vm.$confirm('确认删除？', {
            //       type: 'warning'
            //     }).then(() => {
            //       httpGet(`bomanalysis/deletebom?id=${params.data.ID}`).then(
            //         res => {
            //           if (res.Code === 0 && res.Data) {
            //             vm.onBindData();
            //             vm.$succMess('删除成功');
            //           } else {
            //             vm.$erroMess(res.Message);
            //           }
            //         }
            //       );
            //     });
            //   }
            // }
          ]
        };

        if (isZnl) {
          OperationColumn.width = 150;
          cellRendererParams.buttons.push({
            text: '发送',
            props({ data } = params) {
              return {
                disabled: data.Status === 3
              };
            },
            click(params) {
              vm.sendBom(params.data);
            }
          });
          cellRendererParams.buttons.push({
            text: '撤销',
            click(params) {
              vm.cancelBom(params.data);
            }
          });
        }

        OperationColumn.cellRendererParams = cellRendererParams;
      }
      this.$refs.grid.changeColumns(Cols);
    },
    // 导出
    exportExcel(data) {
      const vm = this;
      const Loading = vm.$loading({
        text: '正在导出，请稍后...'
      });
      function closeLoading() {
        const TimeID = setTimeout(() => {
          Loading.close();
        }, 1000);
      }
      httpGet(`tradeCentre/GetBomDataFile?id=${data.ID}`, null, {
        baseURL: 'up'
      })
        .then(res => {
          closeLoading();
          if (res.Code === 0) {
            const filepath = `${Config.DATA_API_UPURL}tradeCentre/downloadQuote/${res.Data}`;
            if (window && window.cefQuery) {
              window.cefQuery({
                request: 'downloadFile',
                data: JSON.stringify({
                  FileName: data.Name + '.csv',
                  FileUrl: filepath,
                  Status: true
                }),
                onSuccess: () => {
                  vm.$BomMessage('导出成功');
                },
                onFailure(err) {
                  console.log('window.cefQuery-fail', err);
                }
              });
            } else {
              const name = data.Name;
              const a = document.createElement('a');
              a.setAttribute('href', filepath);
              a.setAttribute('download', name);
              a.click();
              vm.$BomMessage('导出成功');
            }
          }
        })
        .catch(err => {
          console.log(err);
          closeLoading();
        });
    },
    dataTimeChange(value) {
      this.dataTime = value ? value : ['', ''];
      this.onBindData();
    },
    clearParams() {
      this.$refs.dateinput.clear();
      this.BomName = '';
      this.dataTime = ['', ''];
      this.onBindData();
    },
    seachHandler() {
      this.onBindData();
    },
    onBindData(PageIndex = 1) {
      this.loading = true;
      this.dataTime = this.dataTime ? this.dataTime : ['', ''];
      httpPost('bomanalysis/getbomlist', {
        BomName: this.BomName,
        StartDate: this.dataTime[0] ? this.dataTime[0] : null,
        EndDate: this.dataTime[1] ? this.dataTime[1] : null,
        PageIndex,
        PageSize: this.pageSize
      }).then(res => {
        this.loading = false;
        if (res.Code === 0) {
          const DATAS = res.Data.ResultList || [];
          this.pageIndex = res.Data.PageIndex || 1;
          this.totalCount = res.Data.TotalCount || 1;
          this.datas = DATAS;
        }
      });
    },
    sendBom(data) {
      httpGet(`bomanalysis/sendBomToVip?bomId=${data.ID}`).then(res => {
        if (res.Code === 0 && res.Data) {
          this.$succMess('发送成功');
          this.$refs.grid.updateRowData(Object.assign(data, { Status: 2 }));
        } else {
          this.$erroMess(res.Message || '操作失败');
        }
      });
    },
    cancelBom(data) {
      httpGet(`bomanalysis/cancelBomToVip?bomId=${data.ID}`).then(res => {
        if (res.Code === 0 && res.Data) {
          this.$succMess('撤销成功');
          this.$refs.grid.updateRowData(Object.assign(data, { Status: 1 }));
        } else {
          this.$erroMess(res.Message || '操作失败');
        }
      });
    }
  },
  mounted() {
    this.initColumns();
  }
};
</script>
<style lang="scss">
.p-MyBOM {
  .header-marginleft {
    margin-left: 10px;
  }
  .el-table__empty-block {
    min-height: 400px;
  }
  .cell-aContainer {
    a {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
